import { useHeaders } from "hooks/api/useHeaders";
import { useMutation } from "react-query";
import { deleteAssetReq } from "api/assets";

export const useAssetDelete = (onSuccess: (data: number, variables: number) => void) => {
    const headers = useHeaders();

    return useMutation((id: number) => deleteAssetReq(headers, id), { onSuccess });
};
